var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.216797 6.06445C0.216797 6.31055 0.303385 6.52018 0.476562 6.69336C0.64974 6.86198 0.857096 6.94629 1.09863 6.94629H5.125V10.9727C5.125 11.2096 5.20931 11.4147 5.37793 11.5879C5.54655 11.7611 5.75391 11.8477 6 11.8477C6.24154 11.8477 6.44889 11.7611 6.62207 11.5879C6.79525 11.4147 6.88184 11.2096 6.88184 10.9727V6.94629H10.9082C11.1452 6.94629 11.3503 6.86198 11.5234 6.69336C11.6966 6.52018 11.7832 6.31055 11.7832 6.06445C11.7832 5.82292 11.6966 5.61556 11.5234 5.44238C11.3503 5.26921 11.1452 5.18262 10.9082 5.18262H6.88184V1.16309C6.88184 0.921549 6.79525 0.714193 6.62207 0.541016C6.44889 0.367839 6.24154 0.28125 6 0.28125C5.75391 0.28125 5.54655 0.367839 5.37793 0.541016C5.20931 0.714193 5.125 0.921549 5.125 1.16309V5.18262H1.09863C0.857096 5.18262 0.64974 5.26921 0.476562 5.44238C0.303385 5.61556 0.216797 5.82292 0.216797 6.06445Z",
    fill: "#052C42",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusImg);
export default __webpack_public_path__ + "static/media/plusImg.a78589c79e5b7c2c2463e1f138406640.svg";
export { ForwardRef as ReactComponent };